const passwordPolicies = {
  'An error occurred. Please try again later.': 'an-error-occurred',
  'Attempt limit exceeded, please try after some time.': 'attempt-limit-exceeded',
  'Invalid code provided, please request a code again.': 'invalid-code-provided',
  'Invalid verification code provided, please try again.': 'invalid-verification-provided',

  // Settings page
  'Password does not conform to policy: Password not long enough': 'password-not-long-enough',
  'Password does not conform with policy: Password not long enough': 'password-not-long-enough',
  'Password did not conform with policy: Password not long enough': 'password-not-long-enough',

  'Password does not conform to policy: Password must have lowercase characters': 'password-missing-lowercase',
  'Password does not conform with policy: Password must have lowercase characters': 'password-missing-lowercase',
  'Password did not conform with policy: Password must have lowercase characters' :  'password-missing-lowercase',

  'Password does not conform to policy: Password must have uppercase characters': 'password-missing-uppercase',
  'Password does not conform with policy: Password must have uppercase characters': 'password-missing-uppercase',
  'Password did not conform with policy: Password must have uppercase characters': 'password-missing-uppercase',

  'Password does not conform to policy: Password must have numeric characters': 'password-missing-number',
  'Password does not conform with policy: Password must have numeric characters': 'password-missing-number',
  'Password did not conform with policy: Password must have numeric characters': 'password-missing-number',

  "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\\S]+.*[\\S]+$": 'password-validation-error',
  "1 validation error detected: Value at 'proposedPassword' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[\S]+.*[\S]+$" : 'password-validation-error',

  'Incorrect username or password.': 'incorrect-username-or-password',
  'Your password has been changed.': 'your-password-has-been-changed',
  'User is already registered!': 'user-is-already-registered',
};
type Keys = keyof typeof passwordPolicies;
export const apiPasswordPolicyMessage = (key: Keys):string => {
  const message = passwordPolicies[key];
  return message ? message : "password-validation-error";
}
export default apiPasswordPolicyMessage;
